<template>
  <div class="component-layer" v-if="value">
    <div class="wrap" :style="{width: width}">
      <slot></slot>
      <div :class="`close iconfont huaban ${close}`" @click="closeFn"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-layer',
  props: {
    value: {
      type: Boolean
    },
    close: {
      type: String,
      default: 'center-bottom'
    },
    width: {
      type: String,
      default: '2.7rem'
    }
  },
  data () {
    return {}
  },
  methods: {
    closeFn () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
$gray = rgba(255, 255, 255, .5)
.wrap
  position absolute
  left 50%
  top 45%
  transform translate(-50%, -50%)
.close
  position absolute
  width .36rem
  height .36rem
  color $gray
  font-size .18rem
  text-align center
  line-height .3rem
  border .03rem $gray solid
  border-radius 50%
  &.center-bottom
    left 50%
    bottom -.51rem
    transform translateX(-50%)
.component-layer
  z-index 9
  position fixed
  width 100%
  height 100%
  max-width 750px
  left 50%
  top 0
  transform translateX(-50%)
  background rgba(0, 0, 0, .6)
</style>
